export class AuthTokenError extends Error {
  constructor() {
    super("Error with authentication token.");
    this.name = "AuthTokenError";

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, AuthTokenError);
    }
  }
}
